export function getPointsPerMatch(themeData) {
  const raw = themeData?.points_per_charm ?? themeData?.points;
  const n = Number.parseInt(String(raw ?? ""), 10);
  return Number.isFinite(n) && n > 0 ? n : 10;
}

export function parseTimeToSeconds(t) {
  if (t == null) return 0;
  if (typeof t === "number" && Number.isFinite(t)) return Math.max(0, Math.floor(t));
  const s = String(t).trim();
  if (!s) return 0;
  if (/^\d+$/.test(s)) return Number.parseInt(s, 10) || 0;
  const parts = s.split(":").map((p) => Number.parseInt(String(p).trim(), 10) || 0);
  if (parts.length >= 3) return parts[0] * 3600 + parts[1] * 60 + parts[2];
  if (parts.length >= 2) return parts[0] * 60 + parts[1];
  return 0;
}

export function formatMmSs(totalSec) {
  const t = Math.max(0, Math.floor(Number(totalSec) || 0));
  const m = Math.floor(t / 60);
  const s = t % 60;
  return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
}
